import { useMemo, useState } from 'react';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import DashboardResultsHeader from './DashboardResultsHeader/DashboardResultsHeader';
import { StatsPeriods } from './DashboardResults.types';
import { DashboardResultsContext } from './DashboardResults.context';
import DashboardResultsTable from './DashboardResultsTable/DashboardResultsTable';
import DashboardResultsCustomModal from './DashboardResultsCustomModal/DashboardResultsCustomModal';
import moment from 'moment';

export default () => {
  const [isDateModalOpen, setDateModalOpen] = useState(false);
  const [currentPeriod, setCurrentPeriod] = useState<StatsPeriods>(StatsPeriods.Day);
  const [currentDates, setCurrentDates] = useState<Date[]>([moment().toDate()]);

  const contextValue = useMemo(
    () => ({
      isDateModalOpen,
      setDateModalOpen,
      currentPeriod,
      setCurrentPeriod,
      currentDates,
      setCurrentDates,
    }),
    [
      isDateModalOpen,
      setDateModalOpen,
      currentPeriod,
      setCurrentPeriod,
      currentDates,
      setCurrentDates,
    ]
  );

  return (
    <DashboardResultsContext.Provider value={contextValue}>
      <DashboardLayout>
        <DashboardResultsHeader />
        <DashboardResultsTable />
        <DashboardResultsCustomModal isOpen={isDateModalOpen} setOpen={setDateModalOpen} />
      </DashboardLayout>
    </DashboardResultsContext.Provider>
  );
};
